import React, {useState, useEffect} from 'react';

import {Button, Spinner, Modal, SelectionInput} from 'player-components';
import './style.css';

import { RWebShare } from "react-web-share";

import { ExclamationCircleIcon } from '@heroicons/react/20/solid';

const ShareSetlistModal = ({setlist, isOpen, onClose}) => {
    
    const formUrlFromSetlist = (setlist) => {
        return `${process.env.PUBLIC_URL}/setlist?setlistId=${setlist.id}&title=${setlist.title}&subtitle=${setlist.subTitle}&imageUrl=${btoa(setlist.imageUrl)}&items=${setlist.items.map(s => s.songId)}`;

    }

    const renderCannotShare = () => {
        return <div>
            <div className="text-primary flex text-center justify-center mb-4 mt-4"><ExclamationCircleIcon className="h-20 w-20" /></div>
            <p className="text-center">You cannot share this setlist yet as it has no songs in it.</p>
        </div>
    }

    return <Modal 
        isOpen={isOpen }
        content={<div>
        {setlist && setlist.items.length ? <div>
            <code style={{wordBreak:'break-all'}}>{formUrlFromSetlist(setlist)}</code>
            <RWebShare
                data={{
                text: `Listen to my ChoirPlayer ${setlist.title} setlist`,
                url: `${process.env.PUBLIC_URL}${formUrlFromSetlist(setlist)}`,
                title: `${setlist.title} setlist`,
            }}
            onClick={() => console.log("shared successfully!")}
      >
        <Button>Share  </Button>
      </RWebShare>
        </div>: renderCannotShare()}
        </div>}
        closeLabel={'Close'}
        onClose={onClose}
        title="Share setlist"
    />
}

export default ShareSetlistModal;